"use client";
import { AppOptionType } from "@/models";
import {
  MenuItemProps,
  Select,
  SelectProps,
  SxProps,
  Theme,
} from "@mui/material";
import { forwardRef, memo } from "react";
import AppMenuItem from "./AppMenuItem";
import AppFormControlLoading from "./form-control/AppFormControlLoading";

const AppSelect = forwardRef(
  (
    {
      sx,
      options,
      menuItemProps,
      isLoading,
      label,
      size,
      ...otherProps
    }: AppSelectProps,
    ref
  ) => {
    return (
      <>
        {isLoading && <AppFormControlLoading size={size} />}
        {!isLoading && (
          <Select
            label={label}
            size={size}
            sx={{ ...appSelectStyles, ...(sx as object) }}
            // IconComponent={ArrowIcon}
            {...otherProps}
            ref={ref}
          >
            {options.length === 0 ? (
              <AppMenuItem
                sx={{
                  "&.Mui-selected": {
                    color: "text.secondary",
                  },
                }}
                value=""
                disabled
              >
                Không có dữ liệu
              </AppMenuItem>
            ) : (
              options.map((item, index) => (
                <AppMenuItem
                  value={item.value ?? undefined}
                  key={index}
                  disabled={"disabled" in item ? Boolean(item.disabled) : false}
                  {...menuItemProps}
                >
                  <>{item.label}</>
                </AppMenuItem>
              ))
            )}
          </Select>
        )}
      </>
    );
  }
);
AppSelect.displayName = "AppSelect";
export default memo(AppSelect);
export type AppSelectProps = Omit<
  SelectProps & { options: AppOptionType[]; menuItemProps?: MenuItemProps },
  "children"
> & {
  isLoading?: boolean;
};

export const appSelectStyles: SxProps<Theme> = {
  textAlign: "left",
  backgroundColor: "common.white",
  height: 40,
  borderRadius: "4px",
  "&.Mui-focused,&.Mui-focused .MuiSvgIcon-root": {
    color: "primary.main",
  },
  // "& .MuiSvgIcon-root": {
  //   right: 11,
  //   transform: "rotate(-90deg)",
  // },
  // "& .MuiSvgIcon-root.MuiSelect-iconOpen": {
  //   transform: "rotate(90deg)",
  // },
  "&.MuiInputBase-root.Mui-disabled": {
    backgroundColor: "disabled.main",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "disabled.main",
    },
  },
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid",
    borderColor: "border.secondary",
    // boxShadow: "0px 2px 4px 0px #0000000f",
    borderRadius: "4px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "border.secondary",
    borderWidth: 1,
  },
  "&& .MuiSelect-outlined": {
    paddingRight: "40px",
  },
  "& .MuiSvgIcon-root.MuiSelect-icon": {
    width: "40px",
    height: "40px",
    padding: "9px",
    top: 0,
    right: 0,
    // borderLeft: "1px solid",
    // borderColor: "border.secondary",
    // "&.MuiSelect-iconOpen": {
    //   borderRight: "1px solid",
    // },
  },
  "&& .MuiOutlinedInput-input": {
    paddingLeft: "8px",
    paddingRight: "32px",
  },
  "&&.MuiInputBase-sizeSmall": {
    height: "32px",
    ".MuiSvgIcon-root.MuiSelect-icon": {
      width: "32px",
      height: "32px",
      padding: "5px",
    },
  },
  "&& .MuiInputBase-inputSizeSmall": {
    paddingTop: "5px",
    paddingBottom: "5px",
  },
};
